import { gql } from "@apollo/client";

export const GE_COVER_LETTER_URL = gql`
  query getCoverLetterUrl($transactionUUID: String!) {
    getCoverLetterUrl(transactionUUID: $transactionUUID)
  }
`;
